import React from 'react';
import font from '../../assets/fonts/Roboto-Regular.ttf';
import { Document, Page, View, Image, Text, Font, Svg, } from '@react-pdf/renderer';
import { styles, svgIcons } from './styles'
import img from '../../assets/img/nelore.png';

export function PDFDocument({ detalhesAnimal }) {
  const legends = [
    {
      value: 1,
      label: 'Diamante - TOP 1%',
      color: '#A2A3A7',
    },

    {
      value: 5,
      label: 'Esmeralda - TOP 5%',
      color: '#A8DCA8',
    },

    {
      value: 10,
      label: 'Rubi - TOP 10%',
      color: '#F65A70',
    },

    {
      value: 20,
      label: 'Safira - TOP 20%',
      color: '#4B90F0',
    },

    {
      value: 30,
      label: 'Topázio Imperial - TOP 30%',
      color: '#DD895A',
    },

    {
      value: 100,
      label: 'TOP maiores 30%',
      color: '#EFEFEF',
    },
  ];

  const labels = [
    {
      label: 'DIPP',
      key: 'tdipp',
    }, {
      label: 'D3P',
      key: 'tdpP30',
    }, {
      label: 'MP120',
      key: 'tmpP120',
    }, {
      label: 'MP210',
      key: 'tmpP240',
    }, {
      label: 'DP210',
      key: 'tdpP240',
    }, {
      label: 'DP450',
      key: 'tdpP455',
    }, {
      label: 'DSTAY',
      key: 'tdstay',
    }, {
      label: 'DPE365',
      key: 'tdpE365',
    }, {
      label: 'DPE450',
      key: 'tdpE455',
    }, {
      label: 'DAOL',
      key: 'tdaol',
    }, {
      label: 'MGTe',
      key: 'tmgt',
    },
  ];

  return (
    <Document>
      {detalhesAnimal && detalhesAnimal.map((detalhes, index) => {
        return (
          <Page key={`page-${index}`} size="A4" style={styles.body}>

            <View style={styles.page}>

              <View style={styles.container.secondary}>
                <View style={styles.container}>
                  <View style={styles.container.titulo}>
                    <Text style={styles.container.titulo.texto}>{detalhes.title}</Text>
                  </View>
                </View>
                <View style={styles.container.secondary.row}>
                  <View style={styles.container.secondary.row.columns}>
                    <Image
                      style={styles.container.secondary.row.columns.image}
                      src={img}
                    />
                  </View>
                  <View style={styles.container.secondary.row.columns}>
                    <Text style={styles.h2}>{detalhes.nome}</Text>
                    <Text style={styles.text}>
                      <Text style={styles.text.bold}>Proprietário: </Text>{detalhes.proprietario}
                    </Text>
                    <Text style={styles.text}>
                      <Text style={styles.text.bold}>Criador: </Text>{detalhes.criador}
                    </Text>
                  </View>

                  <View style={styles.container.secondary.row.columns}>

                    {detalhes.section_01.map((item, i) =>
                      <View key={`section_01-${i}`} style={styles.container.secondary.row.columns.row}>
                        <View styles={styles.container.secondary.row.columns.row.li}>
                          <Text style={styles.text.blue}>{item.title}</Text>
                        </View>
                        <View styles={styles.container.secondary.row.columns.row.li.text}>
                          <Text style={styles.text}>{item.value}</Text>
                        </View>
                      </View>
                    )}

                  </View>

                  <View style={styles.container.secondary.row.columns}>

                    {detalhes.section_02.map((item, i) => {
                      if (item.title === 'MGTe:') {
                        return (
                          <View key={`mgte-${i}`} style={styles.container.secondary.row.columns.mgte}>
                            <Text style={styles.text.green}>{item.title}</Text>
                            <View style={styles.mgteContent}>
                              {item.values.map((mgte, index) => (
                                <Text key={`mgte-${i*2}`} style={
                                  [styles.mgteValor, {
                                    borderLeft: `${index === 1 ? '1' : '0'} solid #fff`, borderRight: `${index === 1 ? '1' : '0'} solid #fff`
                                  }
                                  ]}>
                                  {mgte.caract}
                                </Text>
                              ))}
                            </View>
                          </View>
                        )
                      } else {
                        return (
                          <View key={`section_02-${i}`} style={styles.container.secondary.row.columns.row}>
                            <View styles={styles.container.secondary.row.columns.row.li}>
                              <Text style={styles.text.blue}>{item.title}</Text>
                            </View>
                            <View styles={styles.container.secondary.row.columns.row.li.text}>
                              <Text style={styles.text}>{item.value}</Text>
                            </View>
                          </View>
                        )
                      }
                    })}

                  </View>

                </View>


                <View style={styles.containerCard}>

                  {detalhes.caracteristicasAgrupadas.map((item, i) => {
                    if (i > 0) {
                      return (
                        <View key={`caract-${i}`} style={styles.card} >
                          <Text style={styles.card.titulo}>{item.caracteristicaSigla}</Text>
                          <View style={styles.card.container}>
                            <Text style={styles.card.columnValor}>{item.caracteristicas.dep}</Text>
                            <Text style={styles.card.columnAcuracia}>@ {item.caracteristicas.acuracia}</Text>
                            <Text style={styles.card.columnTop}>® {item.caracteristicas.top}%</Text>
                          </View>
                        </View>
                      )
                    }
                  })}

                  < View style={styles.containerCardLegend}>
                    <Text style={styles.containerCardLegendText}>@ Acurácia / ® Top / Dep G: DEP Genômica</Text>
                    <Text style={styles.containerCardLegendText}>Em destaques DEP’s que compõe o MTGe</Text>
                  </View>

                  <View style={styles.containerCardSmall}>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NF3P
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NN120
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>


                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NRN120
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NFSTAY
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NF120
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NR120
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NF210
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NR210
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NF450
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NR450
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NFUS
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NRUS
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                    <View style={styles.cardSmall}>
                      <Text style={styles.card.titulo}>NFSAMS
                      </Text>

                      <View style={styles.card.container}>
                        <Text style={styles.cardSmallText}>{0}</Text>
                      </View>
                    </View>

                  </View>

                </View>
              </View>

              <View style={styles.genealogia.container} wrap={false}>
                <Text style={{ fontSize: '12' }}>Genealogia</Text>
                <View style={styles.genealogia}>

                  <View style={styles.genealogia.columns}>
                    {detalhes.genealogia.map((item, i) => {
                      if (item.key === 'avoPai' || item.key === 'avomPai') {
                        return (
                          <View key={`avoPai-${i}`} style={styles.genealogia.card}>
                            <View style={styles.genealogia.content}>
                              <View style={styles.genealogia.header}>
                                <Text style={styles.genealogia.headerText}>{item.title}</Text>
                              </View>
                              <View style={[styles.genealogia.body, styles.genealogia[item.bgColor]]}>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.serie || '---'} / {item.rgn || '---'} / {item.rgd || '---'}</Text>
                                </View>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.nome}</Text>
                                </View>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.valor}</Text>
                                  <Text style={styles.genealogia.bodyContentText}>{item.top}</Text>
                                </View>
                              </View>
                            </View>
                          </View>
                        )
                      }
                    })}
                  </View>
                  <View style={styles.genealogia.columns}>
                    {detalhes.genealogia.map((item, i) => {
                      if (item.key === 'pai') {
                        return (
                          <View key={`pai-${i}`} style={styles.genealogia.card}>
                            <View style={styles.genealogia.content}>
                              <View style={styles.genealogia.header}>
                                <Text style={styles.genealogia.headerText}>{item.title}</Text>
                              </View>
                              <View style={[styles.genealogia.body, styles.genealogia[item.bgColor]]}>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.serie || '---'} / {item.rgn || '---'} / {item.rgd || '---'}</Text>
                                </View>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.nome}</Text>
                                </View>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.valor}</Text>
                                  <Text style={styles.genealogia.bodyContentText}>{item.top}</Text>
                                </View>
                              </View>
                            </View>
                          </View>
                        )
                      }
                    })}
                  </View>
                  <View style={styles.genealogia.columns}>
                    {detalhes.genealogia.map((item, i) => {
                      if (item.key === 'mae') {
                        return (
                          <View key={`mae-${i}`} style={styles.genealogia.card}>
                            <View style={styles.genealogia.content}>
                              <View style={styles.genealogia.header}>
                                <Text style={styles.genealogia.headerText}>{item.title}</Text>
                              </View>
                              <View style={[styles.genealogia.body, styles.genealogia[item.bgColor]]}>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.serie || '---'} / {item.rgn || '---'} / {item.rgd || '---'}</Text>
                                </View>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.nome}</Text>
                                </View>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.valor}</Text>
                                  <Text style={styles.genealogia.bodyContentText}>{item.top}</Text>
                                </View>
                              </View>
                            </View>
                          </View>
                        )
                      }
                    })}
                  </View>
                  <View style={styles.genealogia.columns}>
                    {detalhes.genealogia.map((item, i) => {
                      if (item.key === 'avoMae' || item.key === 'avomMae') {
                        return (
                          <View key={`avoMae-${i}`} style={styles.genealogia.card}>
                            <View style={styles.genealogia.content}>
                              <View style={styles.genealogia.header}>
                                <Text style={styles.genealogia.headerText}>{item.title}</Text>
                              </View>
                              <View style={[styles.genealogia.body, styles.genealogia[item.bgColor]]}>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.serie || '---'} / {item.rgn || '---'} / {item.rgd || '---'}</Text>
                                </View>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.nome}</Text>
                                </View>
                                <View style={styles.genealogia.bodyContent}>
                                  <Text style={styles.genealogia.bodyContentText}>{item.valor}</Text>
                                  <Text style={styles.genealogia.bodyContentText}>{item.top}</Text>
                                </View>
                              </View>
                            </View>
                          </View>
                        )
                      }
                    })}
                  </View>
                </View>
              </View>

              <View style={styles.container} wrap={false}>
                <Text style={{ fontSize: '12' }}>DEPs Gráficas</Text>
                <View style={styles.deps}>
                  <View style={styles.depsContainer}>
                    <View style={styles.chartView}>
                      <View style={styles.chart}>
                        <View style={styles.headerWrap}>
                          <View>
                            <Text style={styles.chartLabel}>TOP</Text>
                            <Text style={styles.chartLabel}>100%</Text>
                          </View>
                          <View>
                            <Text style={styles.chartLabel}>TOP</Text>
                            <Text style={styles.chartLabel}>10%</Text>
                          </View>
                          <View>
                            <Text style={styles.chartLabel}>TOP</Text>
                            <Text style={styles.chartLabel}>1%</Text>
                          </View>
                          <View>
                            <Text style={styles.chartLabel}>TOP</Text>
                            <Text style={styles.chartLabel}>0.1%</Text>
                          </View>
                        </View>

                        <View style={styles.chartWrap}>
                          <View style={styles.chartRow}>
                            {labels.map((label, i) =>
                              <View key={`chart-label-${i}`}>
                                <Text style={styles.chartLabel}>{label.label} -</Text>
                              </View>
                            )}
                          </View>
                          <View style={styles.chartData}>
                            {labels.map((label, i) =>
                              <View key={`chart-bar-${i}`} style={styles.barWrap}>
                                <View
                                  style={[styles.chartBar,
                                  {
                                    width: `${100 - detalhes.caracteristicas[label.key]}%`,
                                    backgroundColor: legends.find(legend => detalhes.caracteristicas[label.key] <= legend.value).color,
                                  }
                                  ]}>
                                </View>
                                <View>
                                  <Text style={styles.chartValue}>{`TOP ${detalhes.caracteristicas[label.key]}%`}</Text>
                                </View>
                              </View>
                            )}
                          </View>

                        </View>
                      </View>
                    </View>

                  </View>
                  <View style={styles.depsContainer}>

                    {detalhes.classification.map((item, i) =>
                      <View key={`classific-${i}`} style={styles.depsLegenda}>
                        <Svg width="16" height="16" viewBox="0 0 90 80" >{svgIcons[i].icon}</Svg>
                        <Text style={[styles.depsTitle, { color: svgIcons[i].color }]}>{item.str01}</Text>
                        <Text style={styles.depsText}>{item.str02}</Text>
                      </View>
                    )}
                  </View>
                </View>
              </View>

            </View>

            <Text style={styles.pageNumbers} render={({ pageNumber, totalPages }) => (
              `${pageNumber} / ${totalPages}`
            )} fixed />
          </Page>
        )
      })}
    </Document >
  );
};

Font.register({
  family: 'Roboto',
  src: font,
  fontStyle: 'normal', fontWeight: 'normal'
});
